import { render, staticRenderFns } from "./myFile.vue?vue&type=template&id=588aa68c&scoped=true"
import script from "./myFile.vue?vue&type=script&lang=js"
export * from "./myFile.vue?vue&type=script&lang=js"
import style0 from "./myFile.vue?vue&type=style&index=0&id=588aa68c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588aa68c",
  null
  
)

export default component.exports